import { calculateFileSize } from '@pba/utils';
import type { Event } from 'models';
import { Attachments, Card, Icon } from 'ui';
import { SaveSingleAttachmentButton } from 'features/attachments';
import { SaveZipButton } from './save-zip-button';

type P = {
  event: Event;
};

const EventDetailAttachments = ({ event }: P) => {
  if (!event.preloadedFiles || event.preloadedFiles.length === 0) {
    return null;
  }

  return (
    <Card
      extra={<SaveZipButton fileIds={event.preloadedFiles.map((file) => file.id)} />}
      title={<Card.Title icon={<Icon icon="attachment-line" />}>Attachments</Card.Title>}
    >
      <Attachments
        attachments={event.preloadedFiles.map((file) => ({
          ...file,
          byteSize: calculateFileSize(file.byteSize),
          extra: <SaveSingleAttachmentButton attachment={file} />,
        }))}
      />
    </Card>
  );
};

export default EventDetailAttachments;
